import React, { useEffect, useState } from 'react';
import TwoColumnYesNoField from '../shared/TwoColumnYesNoField';

const AboutYourFinances = ({ fieldValues }) => {
  const [state, setState] = useState({});

  useEffect(() => {
    const initialState = {};
    Object.keys(fieldValues).forEach((key) => {
      initialState[key] = fieldValues[key] === "Y" ? true : fieldValues[key] === "N" ? false : "";
    });
    setState(initialState);
  }, [fieldValues]);

  const handleCheckboxChange = (fieldId, value) => {
    setState((prev) => {
      const newValue = prev[fieldId] === value ? "" : value; // Toggle logic
      return { ...prev, [fieldId]: newValue };
    });

    const yesElement = document.getElementById(`field-${fieldId}-yes`);
    const noElement = document.getElementById(`field-${fieldId}-no`);

    if (yesElement && noElement) {
      if (value === true) {
        yesElement.checked = true;
        noElement.checked = false;
      } else if (value === false) {
        yesElement.checked = false;
        noElement.checked = true;
      } else {
        yesElement.checked = false;
        noElement.checked = false;
      }

      // Set value on hidden input for saving logic
      const inputElement = document.getElementById(`field-${fieldId}`);
      if (inputElement) {
        inputElement.value = value === true ? "Y" : value === false ? "N" : "";
      }
    }
  };


  const handleSingleCheckbox = (fieldId, value) => {
    setState((prev) => ({ ...prev, [fieldId]: value }));
    const inputElement = document.getElementById(`field-${fieldId}`);
    if (inputElement) {
      inputElement.value = value === true ? "Y" : value === false ? "N" : "";
    }
  };

  const chapterIdsApplicant = ["URLA.X174", "URLA.X175", "URLA.X176", "URLA.X177"];
  const chapterIdsCoApplicant = ["URLA.X178", "URLA.X179", "URLA.X180", "URLA.X181"];

  return (
    <div className="border border-[var(--blue-2)] rounded bg-[#f9f9f9] mb-3">
      <div className="section-header">About Your Finances</div>

      <div className="grid grid-cols-1 md:grid-cols-[3fr_1fr_1fr] p-4 border-[var(--blue-2)] bg-[var(--white)]">
        <div></div>
        <div className="font-semibold text-[var(--slate-grey-2)] text-sm">Applicant</div>
        <div className="font-semibold text-[var(--slate-grey-2)] text-sm">Co-Applicant</div>
      </div>

      <div className="px-4">
        <TwoColumnYesNoField
          question="Are you a co-signer or guarantor on any debt or loan that is not disclosed on this application?"
          ids={["URLA.X96", "URLA.X97"]}
          fieldValues={state}
          onChange={handleCheckboxChange}
        />

        <TwoColumnYesNoField
          question="Are there any outstanding judgments against you?"
          ids={["169", "175"]}
          fieldValues={state}
          onChange={handleCheckboxChange}
        />

        <TwoColumnYesNoField
          question="Are you currently delinquent or in default on a Federal debt?"
          ids={["URLA.X98", "URLA.X99"]}
          fieldValues={state}
          onChange={handleCheckboxChange}
        />

        <TwoColumnYesNoField
          question="Are you a party to a lawsuit in which you potentially have any personal financial liability?"
          ids={["URLA.X100", "URLA.X101"]}
          fieldValues={state}
          onChange={handleCheckboxChange}
        />

        <TwoColumnYesNoField
          question="Have you conveyed title to any property in lieu of foreclosure in the past 7 years?"
          ids={["URLA.X102", "URLA.X103"]}
          fieldValues={state}
          onChange={handleCheckboxChange}
        />

        <TwoColumnYesNoField
          question="Within the past 7 years, have you completed a pre-foreclosure sale or short sale where the property was sold to a third party and the Lender agreed to accept less than the outstanding mortgage balance due?"
          ids={["URLA.X104", "URLA.X105"]}
          fieldValues={state}
          onChange={handleCheckboxChange}
        />

        <TwoColumnYesNoField
          question="Have you had property foreclosed upon in the last 7 years?"
          ids={["URLA.X106", "URLA.X107"]}
          fieldValues={state}
          onChange={handleCheckboxChange}
        />

        <TwoColumnYesNoField
          question="Have you declared bankruptcy within the past 7 years?"
          ids={["265", "266"]}
          fieldValues={state}
          onChange={handleCheckboxChange}
        />

        {/* Bankruptcy Types Section */}
        <div className="grid grid-cols-1 md:grid-cols-[3fr_1fr_1fr] pt-2 pb-6">
          <div className="text-[var(--slate-grey-2)] text-sm font-medium pr-4">
            If YES, identify the type(s) of bankruptcy:
          </div>
          <div className="flex flex-col gap-2">
            {chapterIdsApplicant.map((id, index) => (
              <label key={id} className="checkbox-label">
                <input
                  type="checkbox"
                  className="checkbox-accent"
                  id={`field-${id}`}
                  checked={state[id] === true}
                  onChange={(e) => handleSingleCheckbox(id, e.target.checked)}
                />
                {`Chapter ${[7, 9, 10, 11][index]}`}
              </label>
            ))}
          </div>
          <div className="flex flex-col gap-2">
            {chapterIdsCoApplicant.map((id, index) => (
              <label key={id} className="checkbox-label">
                <input
                  type="checkbox"
                  className="checkbox-accent"
                  id={`field-${id}`}
                  checked={state[id] === true}
                  onChange={(e) => handleSingleCheckbox(id, e.target.checked)}
                />
                {`Chapter ${[7, 9, 10, 11][index]}`}
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutYourFinances;
